import React from 'react'
import PropTypes from 'prop-types'
import {List as RmwcList} from '@rmwc/list'
import '@rmwc/list/styles'

const DrawerList = ({children, ...otherProps}) => <RmwcList {...otherProps}>{children}</RmwcList>

DrawerList.propTypes = {
  children: PropTypes.any
}

export {DrawerList}
